import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Text } from 'react-orange-ui';
import { Alert } from 'react-onei';

import Indications from './Indications';
import Images from './Images';
import device from '../../helpers/breakpoints';
import WordingService from '../../services/WordingService';

const Container = styled.div`
  display: flex;
  
  @media ${device.mobile} {
     flex-direction: column;
  }
`;

const Wrapper = styled.div`
  width: 450px;
  margin: 0.5rem 0;
`;

const Captcha = ({ indications, images, errorMessage }) => (
  <Row>
    <Col sm={12}>
      <div id="captcha-block">
        <Text id="captcha-helper">
          {WordingService.getWording('caption', 'captchaHelper')}
        </Text>
        {errorMessage && (
          <Wrapper>
            <Alert mini variant="error" id="captcha-error-message" title={errorMessage} tabindex="0" />
          </Wrapper>
        )}
        <Container>
          <Indications indications={indications} />
          <Images images={images} />
        </Container>
      </div>
    </Col>
  </Row>
);

Captcha.defaultProps = {
  errorMessage: null,
};

Captcha.propTypes = {
  /** Array list of indications string */
  indications: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Array list of images properties */
  images: PropTypes.arrayOf(PropTypes.shape({
    format: PropTypes.string,
    value: PropTypes.number,
    data: PropTypes.string,
  })).isRequired,
  errorMessage: PropTypes.string,
};

export default Captcha;
